<template>
    <div>
        <!-- 导航栏：根据页面 & 滚动自动切换样式 -->
        <div :class="[
            fixedClass,
            transClass,
            'top-0 left-0 w-full z-50 transition-all duration-300'
        ]">
            <div class="md:max-w-[56%] max-w-[94%] mx-auto md:px-4 flex items-center justify-between h-[80px]">
                <!-- LOGO -->
                <div class="flex items-center cursor-pointer" @click="$router.push('/')">
                    <img :src="isHome && isTransparent ? require('@/assets/logo_H.png') : require('@/assets/logo.png')"
                        alt="logo" class="w-[124px]">
                </div>
                <!-- 桌面端：横向菜单 + 搜索框 -->
                <div class="hidden md:flex items-center gap-6">
                    <el-menu mode="horizontal" :background-color="menuBg" :text-color="menuText"
                        :active-text-color="menuActive" class="border-none" :default-active="$route.path" router>
                        <el-menu-item index="/">首页</el-menu-item>
                        <el-submenu index="/product">
                            <template slot="title">产品中心</template>
                            <el-menu-item index="/product/1">食用菌</el-menu-item>
                            <el-menu-item index="/product/2">智慧蘑菇仓</el-menu-item>
                        </el-submenu>
                        <el-menu-item index="/solution">解决方案</el-menu-item>
                        <el-menu-item index="/news">新闻动态</el-menu-item>
                        <el-submenu index="/about">
                            <template slot="title">关于菌丰</template>
                            <el-menu-item index="/about/company">公司介绍</el-menu-item>
                            <el-menu-item index="/about/base">基地介绍</el-menu-item>
                            <!-- <el-menu-item index="/about/contact">在线联系</el-menu-item> -->
                        </el-submenu>
                    </el-menu>
                    <div class="w-48">
                        <el-input placeholder="搜索" suffix-icon="el-icon-search" size="small"
                            :class="isHome && isTransparent ? 'search-white' : 'search-black'" v-model="searchVal" />
                    </div>
                </div>
                <!-- 移动端：汉堡按钮【改动：增加relative定位容器】 -->
                <div class="md:hidden">
                    <div class="flex items-center relative">
                        <div class="relative z-10 mr-4">
                            <el-input placeholder="搜索" suffix-icon="el-icon-search" size="mini"
                                :class="isHome && isTransparent ? 'search-white' : 'search-black'"
                                v-model="searchVal" />
                        </div>
                        <!-- <i :class="[
                            isHome && isTransparent ? 'text-white' : 'text-black',
                            'el-icon-menu text-[28px] cursor-pointer'
                        ]" @click="toggleMobileMenu">
                        </i> -->

                        <svg width="18" @click="toggleMobileMenu" height="15" viewBox="0 0 18 15" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.896136 1.74545H16.5586C17.0543 1.74545 17.4548 1.35455 17.4548 0.872727C17.4548 0.391136 17.0545 0 16.5586 0H0.896136C0.401364 0 0 0.390909 0 0.872727C0 1.35455 0.401364 1.74545 0.896136 1.74545ZM16.5584 6.10909H0.896136C0.400227 6.10909 0 6.5 0 6.98182C0 7.46364 0.400227 7.85455 0.896136 7.85455H16.5586C17.0543 7.85455 17.4548 7.46364 17.4548 6.98182C17.4545 6.5 17.0518 6.10909 16.5584 6.10909ZM16.5584 12.2902H0.896136C0.401591 12.2902 0 12.6811 0 13.163C0 13.6448 0.401364 14.0357 0.896136 14.0357H16.5586C17.0543 14.0357 17.4548 13.6448 17.4548 13.163C17.4545 12.6814 17.0543 12.2902 16.5584 12.2902Z"
                                :fill="isHome && isTransparent ? '#fff' : '#000'" />
                        </svg>


                        <!-- ========== 移动端下拉菜单【改动：改成绝对定位，按钮正下方小块面板】 ========== -->
                        <!-- <div v-if="isMobileMenuOpen"
                            class="md:hidden absolute top-full right-0 mt-1 bg-white shadow-lg w-[80px] z-[60]">
                            <div class="px-4 py-2 flex flex-col text-[12px]">
                                <div class="py-1 cursor-pointer" @click="goPage('/product/2')">产品中心</div>
                                <div class="py-1 cursor-pointer" @click="goPage('/solution')">解决方案</div>
                                <div class="py-1 cursor-pointer" @click="goPage('/news')">新闻动态</div>
                                <div class="py-1 cursor-pointer" @click="goPage('/about/company')">关于菌丰</div>
                               </div>
                        </div> -->
                    </div>

                </div>
            </div>
        </div>
        <!-- 占位高度，避免固定导航遮挡内容 -->
        <div class="h-[80px]"></div>

        <el-drawer size="40%" :visible.sync="isMobileMenuOpen" :direction="direction" :before-close="handleClose">
            <div class="flex flex-col px-6 pb-10 text-md">
                <div class="py-2 cursor-pointer" @click="goPage('/product/2')">产品中心 <i class="el-icon-arrow-right ml-4"></i> </div>
                <div class="py-2 cursor-pointer" @click="goPage('/solution')">解决方案 <i class="el-icon-arrow-right ml-4"></i> </div>
                <div class="py-2 cursor-pointer" @click="goPage('/news')">新闻动态 <i class="el-icon-arrow-right ml-4"></i> </div>
                <div class="py-2 cursor-pointer" @click="goPage('/about/company')">关于菌丰 <i class="el-icon-arrow-right ml-4"></i> </div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
export default {
    name: "HeaderNav",
    data() {
        return {
            isTransparent: true,
            isHome: false,
            isMobileMenuOpen: false,
            activeSubMenu: '',
            searchVal: '' //新增
        }
    },
    computed: {
        fixedClass() {
            return "fixed"
        },
        transClass() {
            if (!this.isHome) return "bg-white shadow-md"
            return this.isTransparent ? "bg-transparent" : "bg-white shadow-md"
        },
        textClass() {
            if (!this.isHome) return "text-black"
            return this.isTransparent ? "text-white" : "text-black"
        },
        menuBg() {
            if (!this.isHome) return "#ffffff"
            return this.isTransparent ? "transparent" : "#ffffff"
        },
        menuText() {
            if (!this.isHome) return "#333333"
            return this.isTransparent ? "#ffffff" : "#333333"
        },
        menuActive() {
            return this.isTransparent ? "#ffffff" : "#41B56F"
        }
    },
    watch: {
        $route: {
            handler() {
                this.isHome = this.$route.path === "/"
                this.handleScroll()
                this.closeMobileMenu()
            },
            immediate: true
        }
    },
    mounted() {
        this.isHome = this.$route.path === "/"
        window.addEventListener("scroll", this.handleScroll)
        this.handleScroll()
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll)
    },
    methods: {
        handleScroll() {
            if (!this.isHome) {
                this.isTransparent = false
                return
            }
            const isMobile = window.innerWidth < 768
            if (isMobile) {
                // 移动端：滑动超过 230px 为 true
                this.isTransparent = window.scrollY < 230
            } else {
                // PC端：保持原来逻辑
                this.isTransparent = window.scrollY < window.innerHeight - 50
            }
        },
        goPage(path) {
            this.$router.push(path)
        },
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen
            if (!this.isMobileMenuOpen) {
                this.activeSubMenu = ''
            }
        },
        toggleSubMenu(key) {
            this.activeSubMenu = this.activeSubMenu === key ? '' : key
        },
        closeMobileMenu() {
            this.isMobileMenuOpen = false
            this.activeSubMenu = ''
        }
    }
}
</script>
<style scoped>
::v-deep .el-menu {
    border-bottom: none !important;
}

::v-deep .el-menu-item,
::v-deep .el-submenu__title {
    font-size: 18px !important;
}

::v-deep .el-submenu .el-menu-item {
    font-size: 18px !important;
}

::v-deep .el-menu-item:hover,
::v-deep .el-submenu__title:hover {
    background-color: transparent !important;
}

::v-deep .el-menu-item.is-active,
::v-deep .el-submenu.is-active .el-submenu__title {
    position: relative;
    border-bottom: none !important;
}

::v-deep .el-menu-item.is-active::after,
::v-deep .el-submenu.is-active .el-submenu__title::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 15px;
    height: 2px;
    background: currentColor;
}

::v-deep .el-submenu__icon-arrow {
    display: none !important;
}

/* 搜索框样式 */
::v-deep .el-input {
    border-radius: 99px !important;
}

::v-deep .el-input__inner {
    border-radius: 99px !important;
    padding-right: 35px !important;
    padding-left: 15px !important;
    height: 34px !important;
    border: 1px solid #e5e5e5 !important;
}

::v-deep .el-input__icon {
    right: 12px !important;
    left: auto !important;
    color: #666 !important;
}

::v-deep .el-input__inner {
    background: transparent !important;
}

/* 首页透明状态搜索框白色 */
::v-deep .search-white .el-input__inner {
    border-color: #ffffff !important;
    color: #ffffff !important;
}

::v-deep .search-white .el-input__inner::placeholder {
    color: #ffffff !important;
}

::v-deep .search-white .el-input__icon {
    color: #ffffff !important;
}

/* 白底页面搜索框黑色 */
::v-deep .search-black .el-input__inner {
    border-color: #333333 !important;
    color: #333333 !important;
}

::v-deep .search-black .el-input__inner::placeholder {
    color: #333333 !important;
}

::v-deep .search-black .el-input__icon {
    color: #333333 !important;
}

::v-deep .el-input {
    width: 164px !important;
}
</style>
